
/**
* @props submitButtonProp: object containing properties and methods related to submitButton.
    submitButtonProp={
        submitCb: () => {}
        currentState: loadingState.state,     // loading state string 
        loadingStates: [PAGE_STATE.LOADING, PAGE_STATE.PRELOADING],  // array of states
        text: "Submit",
    }
*/

import React from 'react';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import Drawer from './Drawer';
import styles from './Drawer.styles';
import Loadable from '../loadable/Loadable';

export default function DrawerWithTitleAndFooter({ title, isOpen, onCloseCb, children, customStylesDrawer = {}, submitButtonProp = null, backButtonProp = null, drawerBodyContainerStyles = {}, drawerBodyStyles = {} }) {
    const shouldFooterRender = () => {
        return backButtonProp === null && submitButtonProp === null ;
    }
    
    return (
        <>
            <Drawer isOpen={isOpen} onCloseCb={onCloseCb} customStyles={customStylesDrawer} drawerBodyStyles={drawerBodyStyles}>
                {(title && title != "") ?
                    <div style={styles.header}>
                        <div style={styles.title}>
                            {title}
                        </div>
                    </div>
                    :
                    ""
                }
                <div style={{ ...styles.txDrawerBody, ...drawerBodyContainerStyles, ...(shouldFooterRender() ? styles.maxHeight90 : {}) }} >
                    {children}
                </div>
                { !shouldFooterRender() && 
                    <div style={styles.txDrawerfooter}>
                        <div style={styles.footerButtons}>
                            {
                                (backButtonProp?.text) ?
                                    <Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => backButtonProp.backCb()} disabled={backButtonProp?.disabled || false}>
                                        {backButtonProp.text}
                                    </Button>
                                    :
                                    ""
                            }
                        </div>
                        <div style={styles.footerButtons}>
                            {
                                (submitButtonProp?.text) ?
                                    <Loadable currentState={submitButtonProp?.currentState || ""} loadingStates={submitButtonProp?.loadingStates || []} isNewLoadable={true}>
                                        <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => submitButtonProp.submitCb()} disabled={submitButtonProp?.disabled || false}>
                                            {submitButtonProp.text}
                                        </Button>
                                    </Loadable>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                }
            </Drawer >
        </>
    )
}